import { useEffect, useRef } from 'react';

interface AnimatedPinIconProps {
  size?: number;
  className?: string;
}

const AnimatedPinIcon = ({ size = 24, className = '' }: AnimatedPinIconProps) => {
  const iconRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Load the lordicon script if it's not already loaded
    if (!window.lordicon) {
      const script = document.createElement('script');
      script.src = 'https://cdn.lordicon.com/lordicon.js';
      script.async = true;
      document.head.appendChild(script);
    }

    // Create the lord-icon element
    if (iconRef.current) {
      const lordIcon = document.createElement('lord-icon');
      lordIcon.setAttribute('src', 'https://cdn.lordicon.com/upjgggre.json');
      lordIcon.setAttribute('trigger', 'hover');
      lordIcon.setAttribute('colors', 'primary:#B5292C'); // Using the red-800 color from our theme
      lordIcon.style.width = `${size}px`;
      lordIcon.style.height = `${size}px`;
      lordIcon.style.display = 'block';

      // Clear any existing content and append the new icon
      iconRef.current.innerHTML = '';
      iconRef.current.appendChild(lordIcon);
    }
  }, [size]);

  return (
    <div
      ref={iconRef}
      className={`inline-flex items-center justify-center ${className}`}
      style={{ width: size, height: size }}
    />
  );
};

export default AnimatedPinIcon;
